 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~7d10b95f":"accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~7d10b95f","accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~5dc793ab":"accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~5dc793ab","accountSettings":"accountSettings","addSale~address~auth~authorDetails~becomeSeller~blog~blogArticle~buyUsed~categories~errorPage~home~l~95aef313":"addSale~address~auth~authorDetails~becomeSeller~blog~blogArticle~buyUsed~categories~errorPage~home~l~95aef313","addSale~address~becomeSeller~buyUsed~messages~request~royalties":"addSale~address~becomeSeller~buyUsed~messages~request~royalties","addSale":"addSale","address":"address","becomeSeller":"becomeSeller","buyUsed":"buyUsed","messages":"messages","request":"request","royalties":"royalties","authorDetails":"authorDetails","auth~seriesDetails":"auth~seriesDetails","auth":"auth","seriesDetails":"seriesDetails","blog~blogArticle~home~pages":"blog~blogArticle~home~pages","blog":"blog","blogArticle":"blogArticle","home":"home","pages":"pages","categories":"categories","errorPage":"errorPage","listDetails":"listDetails","lists~listsDetails":"lists~listsDetails","listsDetails":"listsDetails","payment":"payment","payout":"payout","profile":"profile","requestTrack":"requestTrack","royaltiesAuthor":"royaltiesAuthor","royaltiesCustomer":"royaltiesCustomer","searchBooks~searchGenre":"searchBooks~searchGenre","searchBooks":"searchBooks","searchGenre":"searchGenre","searchUsers":"searchUsers","settings":"settings","trackDetails":"trackDetails","userProfile":"userProfile","welcome":"welcome","addressesSettings":"addressesSettings","lists":"lists","mainApp":"mainApp","paymentsSettings":"paymentsSettings","purchases~sales":"purchases~sales","purchases":"purchases","sales":"sales","sellerSettings":"sellerSettings","notifications":"notifications"}[chunkId]||chunkId) + "." + {"accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~7d10b95f":"946556d8","accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~5dc793ab":"e1c2bb9b","accountSettings":"3814e773","addSale~address~auth~authorDetails~becomeSeller~blog~blogArticle~buyUsed~categories~errorPage~home~l~95aef313":"603d4be6","addSale~address~becomeSeller~buyUsed~messages~request~royalties":"b40c1d14","addSale":"3bcc0110","address":"88a7a9f3","becomeSeller":"259351fc","buyUsed":"2c31f415","messages":"0bbf0bbf","request":"359d840b","royalties":"7b8a9a91","authorDetails":"ed843e1c","auth~seriesDetails":"2ca9d1fe","auth":"899744a5","seriesDetails":"fde4686d","blog~blogArticle~home~pages":"2d593f3d","blog":"be37de78","blogArticle":"bef594ea","home":"2dde65e1","pages":"d72b3eb5","categories":"4644784f","errorPage":"3502c4b4","listDetails":"d97cf0d5","lists~listsDetails":"a2cee7fa","listsDetails":"93d32359","payment":"89365cf5","payout":"2c579a26","profile":"0901a6c0","requestTrack":"bc4ff80f","royaltiesAuthor":"b83243ac","royaltiesCustomer":"7c011ba7","searchBooks~searchGenre":"1a1ce6a4","searchBooks":"a63d11bd","searchGenre":"d7c111b1","searchUsers":"2aa8ef3a","settings":"200ed0da","trackDetails":"68a1db56","userProfile":"747eaa1c","welcome":"6f983f2b","addressesSettings":"3bc0dc8a","lists":"80648b4f","mainApp":"3223ceb5","paymentsSettings":"84648ed5","purchases~sales":"bc386b94","purchases":"7ebfbeea","sales":"5c89f047","sellerSettings":"ed4b722b","notifications":"281a7ead","chunk-7e3ee512":"5149d3c2","chunk-049d1bd9":"07e09152"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~7d10b95f":1,"accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~5dc793ab":1,"accountSettings":1,"addSale~address~auth~authorDetails~becomeSeller~blog~blogArticle~buyUsed~categories~errorPage~home~l~95aef313":1,"addSale~address~becomeSeller~buyUsed~messages~request~royalties":1,"addSale":1,"address":1,"becomeSeller":1,"buyUsed":1,"messages":1,"request":1,"royalties":1,"authorDetails":1,"auth~seriesDetails":1,"seriesDetails":1,"blog~blogArticle~home~pages":1,"blog":1,"pages":1,"categories":1,"errorPage":1,"listDetails":1,"lists~listsDetails":1,"listsDetails":1,"payment":1,"payout":1,"profile":1,"requestTrack":1,"royaltiesAuthor":1,"royaltiesCustomer":1,"searchBooks~searchGenre":1,"searchUsers":1,"settings":1,"trackDetails":1,"userProfile":1,"welcome":1,"addressesSettings":1,"lists":1,"mainApp":1,"paymentsSettings":1,"purchases~sales":1,"purchases":1,"sales":1,"sellerSettings":1,"notifications":1,"chunk-049d1bd9":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~7d10b95f":"accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~7d10b95f","accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~5dc793ab":"accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~5dc793ab","accountSettings":"accountSettings","addSale~address~auth~authorDetails~becomeSeller~blog~blogArticle~buyUsed~categories~errorPage~home~l~95aef313":"addSale~address~auth~authorDetails~becomeSeller~blog~blogArticle~buyUsed~categories~errorPage~home~l~95aef313","addSale~address~becomeSeller~buyUsed~messages~request~royalties":"addSale~address~becomeSeller~buyUsed~messages~request~royalties","addSale":"addSale","address":"address","becomeSeller":"becomeSeller","buyUsed":"buyUsed","messages":"messages","request":"request","royalties":"royalties","authorDetails":"authorDetails","auth~seriesDetails":"auth~seriesDetails","auth":"auth","seriesDetails":"seriesDetails","blog~blogArticle~home~pages":"blog~blogArticle~home~pages","blog":"blog","blogArticle":"blogArticle","home":"home","pages":"pages","categories":"categories","errorPage":"errorPage","listDetails":"listDetails","lists~listsDetails":"lists~listsDetails","listsDetails":"listsDetails","payment":"payment","payout":"payout","profile":"profile","requestTrack":"requestTrack","royaltiesAuthor":"royaltiesAuthor","royaltiesCustomer":"royaltiesCustomer","searchBooks~searchGenre":"searchBooks~searchGenre","searchBooks":"searchBooks","searchGenre":"searchGenre","searchUsers":"searchUsers","settings":"settings","trackDetails":"trackDetails","userProfile":"userProfile","welcome":"welcome","addressesSettings":"addressesSettings","lists":"lists","mainApp":"mainApp","paymentsSettings":"paymentsSettings","purchases~sales":"purchases~sales","purchases":"purchases","sales":"sales","sellerSettings":"sellerSettings","notifications":"notifications"}[chunkId]||chunkId) + "." + {"accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~7d10b95f":"4ecd8569","accountSettings~addSale~address~addressesSettings~auth~authorDetails~becomeSeller~blog~blogArticle~b~5dc793ab":"2200aabf","accountSettings":"9726efd7","addSale~address~auth~authorDetails~becomeSeller~blog~blogArticle~buyUsed~categories~errorPage~home~l~95aef313":"d6596c0c","addSale~address~becomeSeller~buyUsed~messages~request~royalties":"97507273","addSale":"5eb79ea6","address":"5cd90c7f","becomeSeller":"a90c336f","buyUsed":"0ca722e2","messages":"0b26cb16","request":"948c9665","royalties":"6f957c3a","authorDetails":"fa6085bf","auth~seriesDetails":"0c3b6ada","auth":"31d6cfe0","seriesDetails":"e2dd1ef8","blog~blogArticle~home~pages":"8cdb51e5","blog":"3711cc2a","blogArticle":"31d6cfe0","home":"31d6cfe0","pages":"359d470f","categories":"51bb21e1","errorPage":"21fb8bce","listDetails":"79f3f030","lists~listsDetails":"749adfe2","listsDetails":"de1beb0b","payment":"8aaecfb8","payout":"1b7ad92b","profile":"c82c59f3","requestTrack":"881a3021","royaltiesAuthor":"f5266666","royaltiesCustomer":"595a30aa","searchBooks~searchGenre":"0b7777cd","searchBooks":"31d6cfe0","searchGenre":"31d6cfe0","searchUsers":"31ae2b3a","settings":"5cfdb2ab","trackDetails":"9a78b1b8","userProfile":"8b3c1521","welcome":"05e68eb7","addressesSettings":"8fd24e3a","lists":"c472eca3","mainApp":"6a7c8a9f","paymentsSettings":"60237f3d","purchases~sales":"10fc0262","purchases":"be33c786","sales":"ae0cf1ff","sellerSettings":"7f1819b3","notifications":"4ddca5cf","chunk-7e3ee512":"31d6cfe0","chunk-049d1bd9":"17e338b3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
